import { removeSpecialCharsAndAccents } from '../utils/url';

export const URL_REGEX = '(http[s]?://)?([^/s]+/)(.*)';
export const BASE_PATH = '/companies';
export const ALTERNATE_PATH = '/company';

export const ROUTES = {
  companies: BASE_PATH,
  followedCompanies: `${BASE_PATH}/my_companies_follow`, // TODO: this is an old route and will be removed once the FS enable_new_logged_in_companies_overview is removed
  managedCompanies: `${BASE_PATH}/my_companies_edit`, // TODO: this is an old route and will be removed once the FS enable_new_logged_in_companies_overview is removed
  mostVisitedCompanies: `${BASE_PATH}/most_visited`, // TODO: this is an old route and will be removed once the FS enable_new_logged_in_companies_overview is removed
  recentlyClaimedCompanies: `${BASE_PATH}/subscriptions`, // TODO: this is an old route and will be removed once the FS enable_new_logged_in_companies_overview is removed
  industries: `${BASE_PATH}/industries`,
  industry: `${BASE_PATH}/industries/:industry`,
  segment: `${BASE_PATH}/industries/:industry/:segment`,
} as const;

type ChangeURLToMobileProps = {
  mobileProtocol: string;
  url: string;
  slug: string;
  isAndroid: boolean;
};

export const changeURLtoMobile = ({
  mobileProtocol,
  url,
  slug,
  isAndroid,
}: ChangeURLToMobileProps) => {
  const re = new RegExp(URL_REGEX);
  const url_parts = re.exec(url);
  const protocol = mobileProtocol || url_parts?.[2];

  const queryString = isAndroid
    ? '?open_app=deeplink_entity_pages_from_companies'
    : '';

  //TODO: Quick fix to avoid issues with Android and entity pages
  if (isAndroid) {
    return `${protocol}/entity/${slug}${queryString}`;
  }

  return `${protocol}entity/${slug}${queryString}`;
};

export const getIndustryRoute = ({
  name = '',
  id,
}: {
  name: string;
  id: string;
}) =>
  `${ROUTES.industries}/${id}-${removeSpecialCharsAndAccents(
    name
  ).toLowerCase()}`;

export const getCompanyIndustryRoute = (
  industryName: string,
  categoryName?: string
) =>
  categoryName
    ? `${ROUTES.industries}/${categoryName}/${industryName}`
    : `${ROUTES.industries}/${industryName}`;

export const EXTERNAL_LINKS = {
  brandmanager: ({ slug }: { slug?: string } = {}) =>
    slug ? `/brandmanager/${slug}` : '/brandmanager',
  teampermissions: ({ companyId }: { companyId?: string } = {}) =>
    companyId ? `/teampermissions/company/${companyId}` : '/teampermissions',
  projobs: '/projobs/settings/jobwish/employer',
  preferences: {
    web: '/jobseeker-criteria?backTo=companies',
    mobileNative: 'jobseeker-criteria/employer',
  },
  search: '/search/companies',
  newCompany: '/pages/new/company',
};

export const getIndustrySearchPageRoute = ({ id }: { id?: string }) => {
  const unscrambledId = id?.split('.')[0];

  return `${EXTERNAL_LINKS.search}?filter.industry[]=${unscrambledId}`;
};
